<template>
    <div class="col-md-12">
        <div class="panel panel-visible">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"/>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"/>Cashflow</div>
            </div>
            <div class="panel-body pn">
                <per-pager v-bind:per-page="pagination.perPage"/>
                <div class="dt-panelmenu clearfix">
                    <div class="dataTables_length">
                        <div class="filter-form">
                            Тип
                            <label>
                                <select v-on:change="updateFilter" :disabled="isLoading" v-model="flow" class="form-control input-sm">
                                    <option v-for="(flow, index) in flows" v-bind:key="index" :value="flow.id">
                                        {{flow.name}}
                                    </option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
                <table class="table table-striped table-hover datatables" id="clients_list">
                    <thead>
                        <tr class="fs11">
                            <th>id</th>
                            <th>Тип</th>
                            <th>Операция</th>
                            <th>Товар/Абонемент</th>
                            <th>Тип оплаты</th>
                            <th>Стоимость</th>
                            <th></th>
                            <th>Дата</th>
                            <th>Инициатор</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(cashflow, index) in cashflows" v-bind:key="index">
                            <td class="fs11">{{cashflow.id}}</td>
                            <td class="fs11">{{flows.find(flow => flow.id === cashflow.flow).name}}</td>
                            <td class="fs11">{{cashflow.typeId ? types.find(type => type.id === cashflow.typeId).name : 'Другое'}}</td>
                            <td class="fs11">{{cashflow.link ? cashflow.link.name : '---' }}</td>
                            <td class="fs11">
                                <select v-model="cashflow.paymentType" v-on:change="changePaymentType(cashflow)">
                                    <option v-for="paymentType in data.paymentTypes" :value="paymentType.id" v-bind:key="paymentType.id">
                                        {{ paymentType.name }}
                                    </option>
                                </select>
                            </td>
                            <td class="sum-cell fs11">
                                <tooltip-input
                                    :value="cashflow.sum"
                                    v-on:save="updateSum(cashflow, $event)"
                                >
                                    {{cashflow.sum | numberFormat(0)}}
                                </tooltip-input>
                            </td>
                            <td class="fs11">
                                {{cashflow.people ? getPeopleName(cashflow) : '---'}}
                            </td>
                            <td class="fs11">{{cashflow.createdAt | dateFormatTimestamp('dd.mm.yyyy')}}</td>
                            <td class="fs11">{{cashflow.creator ? cashflow.creator.fullName : '---'}}</td>
                            <td>
                                <drop-down-button name="Действие" classes="btn-info btn-sm">
                                    <li>
                                        <a v-on:click="remove(cashflow)">
                                            Удалить
                                        </a>
                                    </li>
                                </drop-down-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Cashflow from "../../models/Cashflow";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
            dropDownButton: () => import('../data/DropDownButton'),
            tooltipInput: () => import('../data/TooltipInput'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                data: {
                    paymentTypes: Cashflow.getTypesPayment(),
                },
                isLoading: false,
                flow: Cashflow.FLOW_GAIN,
                flows: Cashflow.getTypesFlow(),
                types: Cashflow.getTypes(),
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                cashflows: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            async load() {
                this.isLoading = true;
                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();

                const {data, headers} = await Cashflow.getList(page, perPage, '-id', ['link', 'clientSubscription', 'people', 'creator'], this.flow);
                this.setData(data, headers);
                this.isLoading = false;
            },
            updateFilter() {
                this.$route.query.page = '1';
                this.load();
            },
            getPeopleName(cashflow) {
                return cashflow.people.fullName;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['cashflow-list']) {
                    return this.$store.state.template.perPages['cashflow-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'cashflow-list', value: value})
            },
            setData(cashflows, headers) {
                this.cashflows = cashflows;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            },
            changePaymentType(cashflow) {
                cashflow.update();
            },
            async remove(cashflow) {
                await cashflow.remove();
                const index = this.cashflows.findIndex(row => row.id === cashflow.id);
                this.cashflows.splice(index, 1);
            },
            async updateSum(cashflow, event) {
                cashflow.sum = event.value;
                Cashflow.updateSum(cashflow.id, event.value);
            },
        },
        metaInfo() {
            return {
                title: 'Cashflow - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
